// DRAWER OBJECTS — fruits & veggies. All cartoon SVGs, swappable later.
const INK = "#2B2320";
const S = { stroke: INK, strokeWidth: 4, strokeLinejoin: "round", strokeLinecap: "round" };

export const Apple = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M50 34 C64 24 84 32 84 54 C84 74 68 88 50 86 C32 88 16 74 16 54 C16 32 36 24 50 34 Z" fill="#FF6B6B" />
      <path d="M50 34 q-2 -12 8 -18" fill="none" strokeWidth="3.5" />
      <path d="M58 18 q14 -6 16 8 q-14 6 -16 -8 z" fill="#7FBF4D" strokeWidth="3.5" />
      <ellipse cx="34" cy="52" rx="7" ry="10" fill="#fff" opacity="0.45" stroke="none" />
    </g>
  </svg>
);

export const Lemon = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <ellipse cx="38" cy="46" rx="16" ry="13" fill="#FFE66D" />
      <ellipse cx="62" cy="44" rx="16" ry="13" fill="#FFE66D" />
      <ellipse cx="50" cy="36" rx="15" ry="12" fill="#FFEC8A" />
      <path d="M24 44 q-4 2 0 4 M76 42 q4 2 0 4" fill="#FFE66D" />
      <circle cx="36" cy="44" r="1.3" fill="#E8C93C" strokeWidth="0.8" />
      <circle cx="60" cy="42" r="1.3" fill="#E8C93C" strokeWidth="0.8" />
      <circle cx="50" cy="34" r="1.3" fill="#E8C93C" strokeWidth="0.8" />
      <path d="M52 26 q10 -6 14 4 q-10 6 -14 -4 z" fill="#7FBF4D" strokeWidth="2.5" />
      <ellipse cx="42" cy="40" rx="5" ry="3" fill="#fff" opacity="0.6" stroke="none" />
      <path d="M18 52 h64 a32 26 0 0 1 -64 0 z" fill="#F6F9FC" />
      <ellipse cx="50" cy="52" rx="32" ry="7" fill="#E4ECF2" strokeWidth="3" />
      <path d="M24 58 q-2 10 4 16" stroke="#fff" strokeWidth="3.5" fill="none" opacity="0.9" />
    </g>
  </svg>
);

export const Tomato = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <circle cx="50" cy="58" r="30" fill="#FF6B6B" />
      <path d="M24 62 q4 12 16 18" stroke="#E8563F" strokeWidth="4" fill="none" opacity="0.55" />
      <path d="M50 28 v-8" fill="none" strokeWidth="3.5" />
      <path d="M50 30 l-16 -3 M50 30 l16 -3 M50 30 l-9 10 M50 30 l9 10" stroke="#4F9D4F" strokeWidth="5" fill="none" />
      <ellipse cx="38" cy="50" rx="8" ry="5" fill="#fff" opacity="0.55" stroke="none" />
      <ellipse cx="44" cy="44" rx="3" ry="2" fill="#fff" opacity="0.7" stroke="none" />
    </g>
  </svg>
);

export const Chilli = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M58 26 q-6 1 -6 7 q2 4 7 1 q5 -3 2 -7" fill="#4F9D4F" />
      <path d="M60 32 q20 4 26 22 q1 6 -4 6 q-18 -4 -26 -22" fill="#6FB845" />
      <path d="M58 24 q-2 -6 4 -8" fill="none" strokeWidth="3" />
      <path d="M64 40 q10 4 14 12" stroke="#93D279" strokeWidth="2.5" fill="none" />
      <path d="M28 34 q-8 2 -7 10 q3 5 9 1 q6 -5 3 -9 q-3 -3 -5 -2 z" fill="#4F9D4F" />
      <path d="M30 42 q30 4 42 30 q2 8 -5 9 q-28 -6 -42 -31" fill="#5EA332" />
      <path d="M28 32 q-3 -8 5 -11" fill="none" strokeWidth="3.5" />
      <path d="M40 50 q16 6 26 20" stroke="#93D279" strokeWidth="2.5" fill="none" />
      <path d="M68 74 q6 1 6 -5" stroke="#7FBF4D" strokeWidth="2.5" fill="none" />
    </g>
  </svg>
);

export const Carrot = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M46 34 q14 4 12 14 l-14 36 q-4 8 -10 2 q-12 -22 -6 -44 q4 -10 18 -8 z" fill="#F97316" />
      <path d="M40 48 l14 -4 M36 60 l14 -4 M34 72 l12 -4" strokeWidth="3" fill="none" />
      <path d="M52 30 q8 -12 20 -12 M54 28 q2 -10 -4 -16" fill="none" stroke="#4F9D4F" strokeWidth="5" />
    </g>
  </svg>
);

export const Orange = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <circle cx="50" cy="56" r="30" fill="#FFA94D" />
      <circle cx="40" cy="46" r="1.8" fill="#C2410C" strokeWidth="1.5" />
      <circle cx="56" cy="42" r="1.8" fill="#C2410C" strokeWidth="1.5" />
      <circle cx="62" cy="58" r="1.8" fill="#C2410C" strokeWidth="1.5" />
      <circle cx="44" cy="66" r="1.8" fill="#C2410C" strokeWidth="1.5" />
      <path d="M50 26 q-4 -10 6 -14" fill="none" strokeWidth="3.5" />
      <path d="M56 12 q12 -4 14 8 q-12 4 -14 -8 z" fill="#7FBF4D" strokeWidth="3.5" />
      <ellipse cx="38" cy="48" rx="7" ry="9" fill="#fff" opacity="0.4" stroke="none" />
    </g>
  </svg>
);

export const Onion = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M50 30 C66 30 82 44 80 62 C78 78 66 86 50 86 C34 86 22 78 20 62 C18 44 34 30 50 30 Z" fill="#BE6FA8" />
      <path d="M50 30 q-6 -12 -14 -14 M50 30 q2 -12 12 -14" fill="none" strokeWidth="3.5" />
      <path d="M38 36 q-6 20 2 46 M62 36 q6 20 -2 46 M50 32 v52" fill="none" strokeWidth="2.5" opacity="0.6" />
    </g>
  </svg>
);

export const Potato = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M28 36 q20 -14 40 -4 q16 10 12 30 q-4 18 -26 20 q-22 2 -30 -16 q-6 -18 4 -30 z" fill="#D9A066" />
      <circle cx="42" cy="52" r="2.2" fill="#8B5A2B" strokeWidth="1.5" />
      <circle cx="58" cy="60" r="2.2" fill="#8B5A2B" strokeWidth="1.5" />
      <circle cx="52" cy="42" r="2.2" fill="#8B5A2B" strokeWidth="1.5" />
    </g>
  </svg>
);

export const Broccoli = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M44 60 q-4 18 2 26 h8 q6 -8 2 -26 z" fill="#B7E3A0" />
      <circle cx="34" cy="44" r="14" fill="#4F9D4F" />
      <circle cx="60" cy="40" r="15" fill="#5EA332" />
      <circle cx="46" cy="32" r="13" fill="#4F9D4F" />
      <circle cx="55" cy="52" r="11" fill="#4F9D4F" />
      <circle cx="30" cy="40" r="2" fill="#7FBF4D" strokeWidth="1.5" />
      <circle cx="62" cy="34" r="2" fill="#7FBF4D" strokeWidth="1.5" />
    </g>
  </svg>
);

export const CorianderBunch = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M44 88 h12 l-2 -28 h-8 z" fill="#B7E3A0" />
      <path d="M50 60 q-16 -18 -30 -12 q8 14 26 14 M50 60 q16 -18 30 -12 q-8 14 -26 14 M50 58 q-4 -22 0 -34 q4 12 0 34" fill="#4F9D4F" />
      <circle cx="22" cy="48" r="3" fill="#7FBF4D" strokeWidth="2" />
      <circle cx="78" cy="48" r="3" fill="#7FBF4D" strokeWidth="2" />
      <path d="M40 68 q10 6 20 0" stroke="#E8B968" strokeWidth="5" fill="none" />
    </g>
  </svg>
);

export const Bananas = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M20 44 q10 30 46 34 q12 1 18 -6 q-38 4 -56 -22 q-5 -8 -8 -6 z" fill="#FFD93B" />
      <path d="M28 34 q12 30 46 32 q12 1 18 -5 q-36 2 -54 -21 q-6 -8 -10 -6 z" fill="#FFE066" />
      <path d="M38 26 q14 28 46 28 q10 0 14 -6 q-34 4 -50 -16 q-6 -8 -10 -6 z" fill="#FFD93B" />
      <path d="M20 44 l-3 -5 M28 34 l-3 -5 M38 26 l-3 -5" stroke="#8B5A2B" strokeWidth="3.5" fill="none" />
      <path d="M34 50 q12 18 34 22 M42 40 q14 16 36 18" stroke="#E8B33C" strokeWidth="2.5" fill="none" opacity="0.9" />
      <path d="M46 32 q10 12 26 16" stroke="#FFF3B0" strokeWidth="3" fill="none" opacity="0.9" />
    </g>
  </svg>
);

export const Lettuce = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <circle cx="50" cy="56" r="28" fill="#7FBF4D" />
      <path d="M50 28 a28 28 0 0 1 26 18 q-6 4 -12 -2 q0 8 -8 8 q-8 2 -10 -6 q-6 6 -12 2 q-8 0 -10 -8 a28 28 0 0 1 26 -12 z" fill="#9AD35E" />
      <path d="M50 34 v44 M36 44 q14 8 14 18 M64 44 q-14 8 -14 18" stroke="#4F9D4F" strokeWidth="2.5" fill="none" opacity="0.9" />
      <path d="M32 42 q6 -8 16 -9" stroke="#D3EDBE" strokeWidth="3.5" fill="none" />
    </g>
  </svg>
);

export const Capsicum = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M50 30 q-26 -4 -26 24 q0 26 26 26 q26 0 26 -26 q0 -28 -26 -24 z" fill="#38B000" />
      <path d="M50 32 q-8 2 -8 24 q0 20 8 22 q8 -2 8 -22 q0 -22 -8 -24 z" fill="#45C40C" strokeWidth="2.5" />
      <path d="M30 44 q-4 10 0 20 M70 44 q4 10 0 20" stroke="#2E8C00" strokeWidth="2.5" fill="none" opacity="0.8" />
      <path d="M50 30 q-2 -10 6 -12 q6 -1 6 6" fill="#4F9D4F" />
      <path d="M34 44 q2 -6 8 -8" stroke="#A8E06E" strokeWidth="3.5" fill="none" />
    </g>
  </svg>
);